<df-header-title data-test="header-title"></df-header-title>
<df-header-tabs
  data-test="header-tabs"
  [tabs]="tabs"
></df-header-tabs>
